/**
 * Machine-readable error codes for the FPE API. The shared problem details
 * filter keeps only `detail`, so the server puts the code string in the
 * exception message and clients match on it. Details never carry answers or
 * vitals.
 */ /** HTTP 404: no live FPE record with that id (or its patient is gone). */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FPE_ENCOUNTER_MISMATCH () {
        return FPE_ENCOUNTER_MISMATCH;
    },
    get FPE_FORM_UNKNOWN () {
        return FPE_FORM_UNKNOWN;
    },
    get FPE_INCOMPLETE () {
        return FPE_INCOMPLETE;
    },
    get FPE_LOCKED () {
        return FPE_LOCKED;
    },
    get FPE_NOT_FOUND () {
        return FPE_NOT_FOUND;
    },
    get FPE_PIN_REQUIRED () {
        return FPE_PIN_REQUIRED;
    },
    get FPE_VERSION_CONFLICT () {
        return FPE_VERSION_CONFLICT;
    },
    get FPE_VITALS_WHILE_LINKED () {
        return FPE_VITALS_WHILE_LINKED;
    }
});
const FPE_NOT_FOUND = 'FPE_NOT_FOUND';
const FPE_LOCKED = 'FPE_LOCKED';
const FPE_VERSION_CONFLICT = 'FPE_VERSION_CONFLICT';
const FPE_PIN_REQUIRED = 'FPE_PIN_REQUIRED';
const FPE_INCOMPLETE = 'FPE_INCOMPLETE';
const FPE_ENCOUNTER_MISMATCH = 'FPE_ENCOUNTER_MISMATCH';
const FPE_VITALS_WHILE_LINKED = 'FPE_VITALS_WHILE_LINKED';
const FPE_FORM_UNKNOWN = 'FPE_FORM_UNKNOWN';
